import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [garageName, setGarageName] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const r = await register(email, password, name, garageName);
    setLoading(false);
    if (r.ok) {
      toast.success("Compte créé · votre garage est prêt !");
      navigate("/");
    } else {
      setError(r.error);
      toast.error(r.error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <div className="w-full max-w-md">
        <div className="mb-8">
          <div className="font-display font-black text-lg tracking-tighter leading-tight mb-2">
            <div>GESTION</div>
            <div>CONCESSION</div>
            <div className="text-klein">AUTOMOBILE</div>
          </div>
          <h2 className="font-display font-black text-3xl tracking-tighter">Créer un compte</h2>
          <p className="text-sm text-muted-foreground mt-1">Démarrez votre garage en quelques secondes.</p>
        </div>
        <form onSubmit={onSubmit} className="space-y-5">
          <div>
            <Label htmlFor="garage" className="text-xs uppercase tracking-wider">Nom du garage</Label>
            <Input
              id="garage"
              value={garageName}
              onChange={(e) => setGarageName(e.target.value)}
              placeholder="Ex : Garage Dupont, Auto Center Paris…"
              data-testid="register-garage"
              className="mt-1.5 rounded-sm"
            />
            <p className="text-[11px] text-muted-foreground mt-1">
              Vous êtes l'administrateur. Vous pourrez inviter d'autres utilisateurs ensuite.
            </p>
          </div>
          <div>
            <Label htmlFor="name" className="text-xs uppercase tracking-wider">Votre nom</Label>
            <Input id="name" value={name} onChange={(e) => setName(e.target.value)} required data-testid="register-name" className="mt-1.5 rounded-sm" />
          </div>
          <div>
            <Label htmlFor="email" className="text-xs uppercase tracking-wider">Email</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="register-email" className="mt-1.5 rounded-sm" />
          </div>
          <div>
            <Label htmlFor="password" className="text-xs uppercase tracking-wider">Mot de passe</Label>
            <Input id="password" type="password" minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="register-password" className="mt-1.5 rounded-sm" />
          </div>
          {error && <div className="text-sm text-destructive" data-testid="register-error">{error}</div>}
          <Button type="submit" disabled={loading} data-testid="register-submit" className="w-full rounded-sm bg-klein hover:bg-blue-800 text-white">
            {loading ? "Création…" : "Créer le compte"}
          </Button>
          <p className="text-sm text-muted-foreground text-center">
            Déjà inscrit ?{" "}
            <Link to="/login" className="text-klein hover:underline" data-testid="link-login">
              Se connecter
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
}
